<template>
  <!-- Figma (node 59161:14985): 行 h-40 / px-8、more_vert 24x24 枠 + gap-8、
       テキスト Spectral p2 (14/24)・下線・Foreground/muted (#756e66) -->
  <button class="flex w-full items-center gap-2 px-2 py-2 text-gray4" type="button" @click="onClick">
    <span class="flex h-6 w-6 shrink-0 items-center justify-center">
      <img alt="" class="h-3 w-auto" src="@/wabunka-src/features/Search/assets/more_vert.svg" />
    </span>
    <span class="font-Spectral text-[14px] leading-6 underline">View more</span>
  </button>
</template>

<script setup lang="ts">
const { onClick } = defineProps<{ onClick: () => void }>();
</script>
